import { ReactNode, ComponentType } from 'react';
import { AgenciesQuery, ResidencesQuery } from '../../graphql/graphql';

export enum BusinessItemsType {
  agencies = 'agencies',
  residences = 'residences'
}

export interface BusinessItemsListPageProps {
  setErrorUI: (arg: boolean) => void;
  title: string;
  hasError: boolean;
  CardComponent: ComponentType;
  items: ResidencesQuery['residences'] | AgenciesQuery['agencies'];
  type?: BusinessItemsType;
  children?: ReactNode;
  loading?: boolean;
}
